import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const PDFEditButton = ({
    isLocked,
    showPdf,
    userPermission,
    editId,
    updateState,
    history,
    rowDetails,
    allActions,
    entering,
}) => {
    return showPdf && userPermission?.processName !== 'Export' ? (
        <OverlayTrigger
            placement='top'
            onEntering={entering}
            overlay={
                <Tooltip
                    id='tooltip'
                    style={{
                        backgroundColor: 'rgb(0, 35, 58)',
                        color: 'white',
                        marginBottom: '20px',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: 'rgb(0, 35, 58)',
                            color: 'white',
                        }}
                    >
                        Edit Document
                    </div>
                </Tooltip>
            }
        >
            {editId !== '' && isLocked !== true ? (
                <a
                    onClick={() => {
                        updateState({
                            single_edit: true,
                        });
                        const currentPath = window.location.pathname.split('/');
                        let pathName = `/${currentPath[1]}/edit`;
                        if (currentPath[1] === 'search') {
                            if (currentPath[2] === undefined)
                                currentPath[2] = 'patients';
                            pathName = `/${currentPath[1]}/${currentPath[2]}/edit`;
                        }
                        history.push({
                            pathname: pathName,
                            search: `?edit=${window.btoa(
                                String(rowDetails.doc_id)
                            )}`,
                        });
                    }}
                >
                    <div
                        className='icon_fun outer-col'
                        style={{
                            display: 'inline-block',
                        }}
                    >
                        <span>
                            <i
                                className={
                                    allActions.hasOwnProperty('show_pdf') &&
                                    allActions.show_pdf.icon !== null
                                        ? allActions.show_pdf.icon
                                        : 'fas fa-file-edit'
                                }
                                style={
                                    allActions.hasOwnProperty('show_pdf') &&
                                    allActions.show_pdf.color !== null
                                        ? {
                                              color: allActions.show_pdf.color,
                                          }
                                        : {}
                                }
                            />
                        </span>
                    </div>
                </a>
            ) : (
                <div
                    className='icon_fun outer-col'
                    style={{
                        display: 'inline-block',
                        cursor: 'not-allowed',
                    }}
                >
                    <span
                        style={{
                            cursor: 'not-allowed',
                        }}
                    >
                        <i
                            className={
                                allActions.hasOwnProperty('show_pdf') &&
                                allActions.show_pdf.icon !== null
                                    ? allActions.show_pdf.icon
                                    : 'fas fa-page-break'
                            }
                            style={{
                                color:
                                    allActions.hasOwnProperty('show_pdf') &&
                                    allActions.show_pdf.color !== null
                                        ? allActions.show_pdf.color
                                        : '#007DBC',
                            }}
                        />
                    </span>
                </div>
            )}
        </OverlayTrigger>
    ) : null;
};
export default PDFEditButton;
